<template>
    <li class="item-container">
        <div class="item" :class="{selected: isSelected, disabled: item.disabled}"
             v-if="isFinalNode() && isNotFiltered()" @click.prevent.stop="toggleSelect(item)">
            <div
                class="item-inner d-flex align-items-center gap-3" 
                :style="{'padding-left':(20*level)+'px'}" 
            >
                <SelectListItemNom class="flex-grow-1" :item="item" v-if="itemType === 'nom'" />
                <SelectListItemDati class="flex-grow-1" :item="item" v-if="itemType === 'dati'" />
                <SelectListItemDatiMonitoring class="flex-grow-1" :item="item" v-if="itemType === 'datiMonitoring'" />
                <i v-if="item.warning" class="fa fa-exclamation-triangle text-warning" :title="warningTooltip"></i>
                <div class="p-1 pl-2">
                    <b-form-checkbox 
                        :checked="item.selected" 
                        :disabled="item.disabled" 
                        size="lg" 
                        style="pointer-events: none;"
                    ></b-form-checkbox>
                </div>
            </div>
        </div>

        <div
            v-if="!isFinalNode() && isNotFiltered()"
            @click.prevent.stop="toggleOpenGroup()"
            class="folder" 
            :class="[{show: opened, disabled: childrenLock || noChildren || groupLockedForUser}, stateSelected]"
        >
            <div class="item-inner d-flex align-items-center" :style="{'padding-left':(30*level)+'px'}">
                <i class="handler fa fa-caret-right fa-lg" ></i>
                <span class="flex-grow-1 text-lg">{{ item.name }}</span>
                <i v-if="childrenWarning || groupLockedForUser" class="fa fa-exclamation-triangle text-warning mr-2" :title="groupLockedForUser ? warningGroupLockedForUser : warningTooltipGroup"></i>
                <span class="text-gray-400 mr-2 text-sm text-mono text-right" style="font-weight: 400; min-width: 5ch;">{{ countSelected }}</span>
                <div @click.prevent.stop="toggleSelectGroup()" class="p-1 pl-2">
                    <i v-if="groupLockedForUser" class="fa fa-lock fa-lg mr-3"></i>
                    <b-form-checkbox 
                        v-else
                        size="lg" 
                        :checked="stateSelected === 'selected'" 
                        :indeterminate="stateSelected === 'selected-partial'"
                        :disabled="childrenLock"
                        style="pointer-events: none;"
                    ></b-form-checkbox>
                </div>
            </div>
            <ul class="wrapper" :style="{height:childrenHeight+'px', transform: 'scaleY(1)'}"> <!-- scaleY(1) is a Fix for Chrome bug -->
                <SelectListItemRenderer
                    v-for="itemChild in itemChildren" 
                    v-if="itemChild" 
                    :key="itemChild.id" 
                    :item="itemChild"
                    :itemType="itemType" 
                    :messages="messages"
                    :level="level+1" 
                    @select="onSelect" 
                    @unselect="onUnselect" 
                />
            </ul>

        </div>

    </li>
</template>

<script>
import Utils from '@/services/utils.js';
import SelectListItemNom from './SelectListItemNom.vue';
import SelectListItemDati from './SelectListItemDati.vue';
import SelectListItemDatiMonitoring from './SelectListItemDatiMonitoring.vue';

export default {
    name: 'SelectListItemRenderer',
    props: {
        item: {type: Object},
        level: {type:Number,required:true},
        itemType: {
            type: String,
            default: 'nom'
        },
        isFiltered: { type: Boolean },
        messages: {
            type: Object,
            default: function () {
                return {
                    lock: {
                        item: Utils.t('profile.form.tooltipDeviceDisabled'),
                        folder: Utils.t('profile.form.tooltipGroupDisabled')
                    }
                }
            }
        }
    },
    components: { 
        SelectListItemNom,
        SelectListItemDati,
        SelectListItemDatiMonitoring
    },
    methods: {
        toggleSelect: function (item, force) {
            if (item.disabled) {
                return;
            }
            if (force != null) {
                item.selected = force;
            }
            else {
                item.selected = !item.selected;
            }
            if (item.selected) {
                this.$emit('select', item);
            }
            else {
                this.$emit('unselect', item);
            }
        },
        toggleSelectGroup: function () {
            this.toggleSelect(this.item);
            for (var childIndex in this.item.children) {
                this.toggleSelect(this.item.children[childIndex], this.item.selected);
            }
        },
        toggleOpenGroup: function () {
            this.opened = !this.opened;
            if (this.opened) {
                this.$emit('open');
            } else {
                this.$emit('close');
            }
        },
        isFinalNode: function () {
            if (this.item && this.item.children != null) {
                return false;
            }
            return true;
        },
        isNotFiltered: function () {
            return !this.item.filtered;
        },
        onSelect: function (item) {
            this.$emit('select', item);
        },
        onUnselect: function (item) {
            this.$emit('unselect', item);
        },
    },
    computed: {
        itemChildren: function () {
            return this.item.children.filter(x => x != null);
        },
        noChildren: function () {
            return this.isFiltered && this.item.children && this.item.children.filter(x => !x.filtered).length === 0
        },
        childrenHeight: function () {
            if (this.opened) {
                return this.item.children.filter(x => !x.filtered).length * (55 + 2);
            }
            else {
                return 0;
            }
        },
        isSelected: function () {
            return this.item.selected;
        },
        disabledTooltip: function () {
            if (this.item.disabled) {
                return this.messages.lock.item;
            }
            return null;
        },
        disabledTooltipGroup: function () {
            return this.messages.lock.folder;
        },
        warningTooltip: function () {
            return Utils.t('profile.form.tooltipDeviceWarning');
        },
        warningTooltipGroup: function () {
            return Utils.t('profile.form.tooltipGroupWarning');
        },
        warningGroupLockedForUser: function () {
            return Utils.t('profile.form.tooltipGroupLockedForUser');
        },
        groupLockedForUser: function () {
            return this.item.lockedForUser
        },
        childrenWarning: function () {
            for (var i = 0; i < this.item.children.length; i++) {
                if (this.item.children[i] && this.item.children[i].warning === true) {
                    return true;
                    break;
                }
            }
            return false;
        },
        childrenLock: function () {
            var lock = true;
            if(this.item.children.length > 0){
                for (var i = 0; i < this.item.children.length; i++) {
                    if (this.item.children[i] && this.item.children[i].disabled !== true) {
                        lock = false;
                        break;
                    }
                }
            }
            else{
                lock = false;
            }
            return lock;
        },
        allSelected: function () {
            if (this.item.children != null) {
                if(this.item.children.length > 0){
                    for (var childIndex in this.item.children) {
                        if (!this.item.children[childIndex].selected) {
                            return false;
                        }
                    }
                }
                else{
                    return false;
                }
            }
            return true;
        },
        stateSelected: function () {
            var nbSelected = 0;
            if (this.item.children != null) {
                for (var childIndex in this.item.children) {
                    if (this.item.children[childIndex].selected) {
                        nbSelected++;
                    }
                }
                if (nbSelected == this.item.children.length) {
                    return 'selected'
                }
                else if (nbSelected > 0) {
                    return 'selected-partial'
                }
            }
            return '';
        },
        countSelected: function () {
            let nbSelected = 0;
            if (!!this.itemChildren.length) {
                const total = this.itemChildren.length || 0;
                for (var childIndex in this.itemChildren) {
                    if (this.itemChildren[childIndex].selected) {
                        nbSelected++;
                    }
                }
                return nbSelected + '/' + total;
            }
        },
    },
    mounted: function () {
        this.item = this.item;
        this.opened = false;
    },
    data: () => ({
        opened: false,
        _item: null,
    })
}
</script>

<style lang="scss" scoped>

</style>